// Configuration settings for the application
// 
// Note: Frontend only uses PUBLIC API Gateway endpoints (JWT authenticated).
// Internal service-to-service endpoints use a separate INTERNAL API Gateway
// with IAM SigV4 authentication, which is configured on the backend side.
const config = {
  // API configuration - All URLs point to the PUBLIC API Gateway
  api: {
    // Auth service endpoint
    authServiceUrl: (() => {
      // Priority order: env URL > default local
      const envUrl = process.env.REACT_APP_AUTH_SERVICE_URL;
      const defaultUrl = 'http://localhost:8000';
      
      const selectedUrl =  envUrl || defaultUrl;
      
      return selectedUrl;
    })(),

    // File service endpoint
    fileServiceUrl: (() => {
      // Priority order: env URL > default local 
      const envUrl = process.env.REACT_APP_FILE_SERVICE_URL;
      const defaultUrl = 'http://localhost:8001';
      
      const selectedUrl = envUrl || defaultUrl;
      
      return selectedUrl;
    })(),

    ccServiceUrl: (() => {
      // Priority order: env URL > default local
      const envUrl = process.env.REACT_APP_CC_SERVICE_URL;
      const defaultUrl = 'http://localhost:8002';
      const selectedUrl = envUrl || defaultUrl;
      return selectedUrl;
    })(),
    
    rrServiceUrl: (() => {
      // Priority order: env URL > default local
      const envUrl = process.env.REACT_APP_RR_SERVICE_URL;
      const defaultUrl = 'http://localhost:8003';
      
      const selectedUrl = envUrl || defaultUrl;
            
      return selectedUrl;
    })(),

    clientServiceUrl: (() => {
      // Priority order: env URL > default local
      const envUrl = process.env.REACT_APP_CLIENT_SERVICE_URL;
      const defaultUrl = 'http://localhost:8004';

      const selectedUrl = envUrl || defaultUrl;

      return selectedUrl;
    })(),

    // Cash Reserves monitoring service endpoint
    cashReservesServiceUrl: (() => {
      // Priority order: env URL > default local
      const envUrl = process.env.REACT_APP_CASH_RESERVES_SERVICE_URL;
      const defaultUrl = 'http://localhost:8022';

      const selectedUrl = envUrl || defaultUrl;

      return selectedUrl;
    })(),

    // Vector service endpoint
    vectorServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_VECTOR_SERVICE_URL;
      const defaultUrl = 'http://localhost:8010';
      return envUrl || defaultUrl;
    })(),

    chatServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_CHAT_SERVICE_URL;
      const defaultUrl = 'http://localhost:8008';
      return envUrl || defaultUrl;
    })(),

    // Bedrock service endpoint
    bedrockServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_BEDROCK_SERVICE_URL;
      const defaultUrl = 'http://localhost:8085';
      return envUrl || defaultUrl;
    })(),

    // Sharepoint service endpoint
    sharepointServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_SHAREPOINT_SERVICE_URL;
      const defaultUrl = 'http://localhost:8020';
      return envUrl || defaultUrl;
    })(),

    // Resources service endpoint
    resourcesServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_RESOURCES_SERVICE_URL;
      const defaultUrl = 'http://localhost:8011';
      return envUrl || defaultUrl;
    })(),

    // Mass Text service endpoint
    massTextServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_MASS_TEXT_SERVICE_URL;
      const defaultUrl = 'http://localhost:8015';
      return envUrl || defaultUrl;
    })(),

    // Client Verification service endpoint
    clientVerificationServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_CLIENT_VERIFICATION_SERVICE_URL;
      const defaultUrl = 'http://localhost:8023';
      return envUrl || defaultUrl;
    })(),

    // Expense Reports service endpoint
    expenseReportsServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_EXPENSE_REPORTS_SERVICE_URL;
      const defaultUrl = 'http://localhost:8027';
      return envUrl || defaultUrl;
    })(),

    // Reference Values service endpoint (annual IRS/SSA limits)
    referenceValuesServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_REFERENCE_VALUES_SERVICE_URL;
      const defaultUrl = 'http://localhost:8028';
      return envUrl || defaultUrl;
    })(),

    // X Search service endpoint
    xServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_X_SERVICE_URL;
      const defaultUrl = 'http://localhost:8012';
      return envUrl || defaultUrl;
    })(),

    // YouTube service endpoint
    youtubeServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_YOUTUBE_SERVICE_URL;
      const defaultUrl = 'http://localhost:8013';
      return envUrl || defaultUrl;
    })(),

    // SEC Filing service endpoint
    secServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_SEC_SERVICE_URL;
      const defaultUrl = 'http://localhost:8091';
      return envUrl || defaultUrl;
    })(),

    // Outlook add-in service endpoint (public API Gateway, JWT-authenticated)
    outlookServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_OUTLOOK_SERVICE_URL;
      const defaultUrl = 'https://localhost:8090';
      return envUrl || defaultUrl;
    })(),

    // Explicit per-environment Outlook URLs so admin tooling (e.g. the
    // client-news subscribe widget) can target QA or prod regardless of which
    // build this is.
    outlookServiceUrlQA: process.env.REACT_APP_OUTLOOK_SERVICE_URL_QA
      || 'https://te7d6ktph0.execute-api.us-east-1.amazonaws.com',
    outlookServiceUrlProd: process.env.REACT_APP_OUTLOOK_SERVICE_URL_PROD
      || 'https://0sd2lz6tz9.execute-api.us-east-1.amazonaws.com',

    // Reviews service endpoint
    reviewsServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_REVIEWS_SERVICE_URL;
      const defaultUrl = 'http://localhost:8016';
      return envUrl || defaultUrl;
    })(),

    // Unified Client Forms service endpoint (cashflow + FPR + future forms)
    clientFormsServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_CLIENT_FORMS_SERVICE_URL;
      const defaultUrl = 'http://localhost:8019';
      return envUrl || defaultUrl;
    })(),

    // Cashflow + FPR keys are kept as aliases pointing at the unified service
    // so older code that still reads them keeps working.
    cashflowServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_CLIENT_FORMS_SERVICE_URL
        || process.env.REACT_APP_CASHFLOW_SERVICE_URL;
      const defaultUrl = 'http://localhost:8019';
      return envUrl || defaultUrl;
    })(),
    fprServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_CLIENT_FORMS_SERVICE_URL
        || process.env.REACT_APP_FPR_SERVICE_URL;
      const defaultUrl = 'http://localhost:8019';
      return envUrl || defaultUrl;
    })(),

    // Redactor service endpoint
    redactorServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_REDACTOR_SERVICE_URL;
      const defaultUrl = 'http://localhost:8098';
      return envUrl || defaultUrl;
    })(),

    // Company Research service endpoint
    researchServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_RESEARCH_SERVICE_URL;
      const defaultUrl = 'http://localhost:8021';
      return envUrl || defaultUrl;
    })(),

    // IPS (Investment Policy Statement) Scanner service endpoint
    ipsServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_IPS_SERVICE_URL;
      const defaultUrl = 'http://localhost:8024';
      return envUrl || defaultUrl;
    })(),

    // Trades service endpoint
    tradesServiceUrl: (() => {
      const envUrl = process.env.REACT_APP_TRADES_SERVICE_URL;
      const defaultUrl = 'http://localhost:8025';
      return envUrl || defaultUrl;
    })(),

    // LSTM Trading Lab - separately deployed static app (own repo/infra:
    // Halter-Ferguson-Financial/LSTM, LSTM-Infra), embedded via iframe.
    // Deliberately NO localhost fallback here: unlike the other service URLs
    // above, an unset value must show a clear "not configured" message
    // (see LstmTradingLab.js) rather than silently iframing localhost in a
    // deployed build - set REACT_APP_LSTM_APP_URL in .env.local for local dev.
    lstmAppUrl: process.env.REACT_APP_LSTM_APP_URL || '',
  },
  
  // Environment configuration
  environment: {
    type: process.env.REACT_APP_ENVIRONMENT || 'local', // 'local', 'aws'
    isLocal: !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'local',
    isAWS: process.env.REACT_APP_ENVIRONMENT === 'aws'
  },
  
  // Authentication configuration
  auth: {
    tokenKey: 'token',
    userKey: 'user',
    expiryKey: 'token_expiry',
    
    // Cognito configuration
    // Note: Set to true to use Cognito, or use REACT_APP_USE_COGNITO=true env var (requires restart)
    useCognito: process.env.REACT_APP_USE_COGNITO === 'true' || true,
    cognitoUserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_WIJNzhaAj',
    cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '27c9tocajtq51hdc0ft090830e',
    cognitoRegion: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
  },
  
  // Feature flags
  features: {
    darkMode: false,
    notifications: false,
    // Enable/disable features based on environment
    debugMode: process.env.NODE_ENV === 'development',
    awsFeatures: process.env.REACT_APP_ENVIRONMENT === 'aws',
  },
  
  // Environment-specific settings
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',
};

// Log configuration in development
if (config.isDevelopment) {
  console.log('Frontend Configuration:', {
    environment: config.environment.type,
    apiUrl: config.api.baseUrl,
    accountServerUrl: config.api.accountServerUrl,
    nodeEnv: process.env.NODE_ENV
  });
}

export default config;
